import { LoadingNote } from "@/components/ui/loading";

/**
 * The router's default while a route's loader runs.
 *
 * Deliberately the plainest of the loading states: a route can be any shape, so
 * there is no skeleton to hold, and a full-screen spinner over a page that is
 * about to arrive is worse than a quiet line saying so. A route that knows its
 * own shape says so with its own `pendingComponent` — `_app` does.
 */
export function PendingPage() {
  return (
    <div className="bg-canvas grid min-h-dvh place-items-center px-5">
      <LoadingNote />
    </div>
  );
}
